import * as sentry from '@sentry/angular';
import { environment } from 'environments/environment';
import { hash } from '../version-hash.json';

sentry.init({
  environment: environment.environment,
  enabled: environment.production,
  dsn: environment.SENTRY_DNS,
  release: `mountdoom@v${hash}`,
  ignoreErrors: [/.*You must be signed in to view this resource.*/i, /ResizeObserver loop completed with undelivered notifications/],
  tracesSampleRate: 0.001,
});

export {
  sentry
};
